module.exports = __webpack_public_path__ + "static/trns-865ab9f12bf5043bba1dc1ea4cc62397.svg";